import React from "react"

import {
  Adornment,
  BoldText,
  Column,
  ItemWrapper,
  PropertyListRoot,
  StyledListItem,
  Title,
  TitleWrapper,
  Wrapper,
} from "./components"
import { MuiIcon } from "@cirrus/ui-kit"

interface IArgs {
  items: {
    icon: React.ReactElement,
    title: string,
    value: string | number
  }[],
  divider?: boolean,
  title?: string
}

export const PropertyTable = ({ divider = true, items, title = "" }) => {
  return (
    <>
      {title && (
        <Wrapper>
          <TitleWrapper>
            <Adornment>
              <MuiIcon.AssignmentTurnedIn />
            </Adornment>
            <Title>{title}</Title>
          </TitleWrapper>
        </Wrapper>
      )}
      <PropertyListRoot>
        {items.map((item) => (
          <StyledListItem
            key={item.title}
            content={
              <ItemWrapper>
                <Column>
                  {item.icon}
                  {item.title}
                </Column>
                <Column>
                  <BoldText>{item.value}</BoldText>
                </Column>
              </ItemWrapper>
            }
            ContentProps={{ disableTypography: true }}
            divider={divider}
          />
        ))}
      </PropertyListRoot>
    </>
  )
}